function scrollTo() {
  const params = new URLSearchParams(window.location.search);
  const anchor = params.get("scroll_to")

  if (anchor == null) {
    return
  }

  const element = document.getElementById(anchor)

  if (element == null) {
    return
  }

  element.scrollIntoView()
}

document.addEventListener("turbo:render", scrollTo)

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scrollTo)
} else {
  scrollTo();
}
